import styled from 'styled-components';
import { BaSeScrollbarCss } from '../../../theme/scrollbar';
import { numberWithUnit } from '../../../utils/string-utils';

interface StyledList {
  columnNum: string | number;
  gap: string | number;
  maxHeight: string | number;
}

interface StyledItem {
  direction: 'column' | 'row' | 'column-reverse' | 'row-reverse';
}

export const WrapperList = styled.ul.attrs({
  className: 'BaSe--list',
})<StyledList>`
  display: grid;
  grid-template-columns: ${({ columnNum }) => `repeat(${columnNum}, 1fr)`};
  gap: ${({ gap }) => numberWithUnit(gap)};
  max-height: ${({ maxHeight }) => numberWithUnit(maxHeight)};
  overflow: auto;
  padding: 16px 4px;
  margin: 0;

  ${BaSeScrollbarCss}
`;

export const Wrapperbtn = styled.div`
  display: flex;
`;

export const WrapperItem = styled.li.attrs({
  className: 'BaSe--list-item',
})<StyledItem>`
  display: flex;
  flex-direction: ${({ direction }) => direction};
  align-items: center;
  justify-content: ${({ direction }) =>
    direction === 'row-reverse' ? 'space-between' : 'none'};
`;
